import { Grid, IconButton, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function DateTimeOptions(props) {
  const { onMonthChange, selectedMonth, availableMonths } = props;

  //Converts all available months to ISO format. Converting so indexOf() works correctly.
  const availableMonthsISO = availableMonths.map((month) => month.toISO());
  //Array position of the currently selected month
  const selectedMonthPosition = availableMonthsISO.indexOf(selectedMonth.toISO());
  //Disable one or both arrows if the selected month is the first, last or only month
  const previousDisabled = selectedMonthPosition === 0;
  const nextDisabled = selectedMonthPosition === availableMonths.length - 1;
  const arrowsDisabled = previousDisabled && nextDisabled;

  // const availableTimesChangeHandler = (event) => {
  //   const checkboxId = event.target.id;
  //   const checked = event.target.checked;

  //   onAvailableTimesChange(checkboxId, checked);
  // };

  const previousMonthHandler = () => {
    if (selectedMonthPosition >= 0) {
      onMonthChange(availableMonths[selectedMonthPosition - 1]);
    }
  };

  const nextMonthHandler = () => {
    if (selectedMonthPosition <= availableMonths.length - 1) {
      onMonthChange(availableMonths[selectedMonthPosition + 1]);
    }
  };

  return (
    <Grid container direction="row" alignItems="center" justifyContent="space-between">
      <Grid item>
        {!arrowsDisabled && (
          <IconButton aria-label="previous" onClick={previousMonthHandler} disabled={previousDisabled} color="primary">
            <ArrowBackIcon />
          </IconButton>
        )}
      </Grid>

      <Grid item>
        <Typography variant="subtitle2" fontSize={16}>
          {selectedMonth.monthLong}
        </Typography>
      </Grid>

      <Grid item>
        {!arrowsDisabled && (
          <IconButton aria-label="next" onClick={nextMonthHandler} disabled={nextDisabled} color="primary">
            <ArrowForwardIcon />
          </IconButton>
        )}
      </Grid>
      {/* </Grid> 
      </Grid>*/}

      {/* <Grid item>
        <Grid container direction="row" alignItems="center">
          <FormControlLabel
            control={<Checkbox id="am" checked={availableTimes.am} onChange={availableTimesChangeHandler} />}
            label="Morning"
          />
          <FormControlLabel
            control={<Checkbox id="pm" checked={availableTimes.pm} onChange={availableTimesChangeHandler} />}
            label="Afternoon"
          />
        </Grid>
      </Grid> */}
    </Grid>
  );
}
